import { render, staticRenderFns } from "./NewCardModal.vue?vue&type=template&id=fb40d046"
import script from "./NewCardModal.vue?vue&type=script&lang=js"
export * from "./NewCardModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports